import { connect } from 'react-redux';
import { getDuperbrowseStreamParent, getCurrentItem, } from '../../Duperbrowse/redux/selectors';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
var mapStateToProps = function (state) {
    var currentItem = getCurrentItem(state);
    var isOwner = currentItem
        ? getIsCurrentUserAuthorOf(state, currentItem)
        : false;
    return {
        parent: getDuperbrowseStreamParent(state),
        currentItem: currentItem,
        isOwner: isOwner,
    };
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=MobileSubmissionDetailsHeader.container.js.map